import {withFormsy} from 'formsy-react';
import React from 'react';
import InputMask from 'react-input-mask';

class MaskedInput extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            formId: this.getId(props)
        }
    }


    changeValue = event => {

        this.props.setValue(event.target.value);
    };


    hashString(inString) {
        let hash = 0;
        for (let i = 0; i < inString.length; i += 1) {
            // eslint-disable-next-line no-bitwise
            hash = ((hash << 5) - hash + inString.charCodeAt(i)) & 0xffffffff;
        }
        return hash;
    }

    getId(props) {
        const _a = props, id = _a.id, label = _a.label, name = _a.name;
        if (id !== '') {
            return id;
        }
        return [
            'frc',
            name
                .split('[')
                .join('_')
                .replace(']', ''),
            this.hashString(JSON.stringify(label)),
        ].join('-');
    }

    render() {
        let props = this.props;
        const errorMessage = props.getErrorMessage();
        let className = props.showRequired() ? 'required ' : '';

        className += !props.isValid() && props.isFormSubmitted() ? 'text-danger' : '';
        let inputClassName = !props.isValid() && props.isFormSubmitted() ? 'is-invalid' : '';
        // getErrorMessage
        // getValue
        // hasValue
        // isFormDisabled
        // isValid
        // isPristine
        // isFormSubmitted
        // isRequired
        // isValidValue
        // resetValue
        // setValidations
        // setValue
        // showRequired
        // showError
        // label
        // type
        // addonBefore
        // required
        // maxLength
        // minLength

        return (
            <div className={"form-group " + className}>
                <label className="col-form-label" data-required="true" htmlFor={this.state.formId}>
                    {props.label}
                    {props.required && <span className="required-symbol"> *</span>}
                </label>

                <InputMask
                    name={props.name}
                    className={"form-control " + inputClassName}
                    required={props.required}
                    disabled={props.disabled}
                    onChange={event => {
                        this.changeValue(event)
                    }}
                    formatChars={props.formatMask}
                    mask={props.mask}
                    value={props.value || ''}
                    id={this.state.formId}
                    maskChar=""/>

                {errorMessage && (
                    <div className="invalid-feedback">
                        <div>{errorMessage}</div>
                    </div>
                )}
            </div>
        )
    }
}


export default withFormsy(MaskedInput);
